import React from "react";
import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {Text} from "@pg-design/text-module";

import {OfferType} from "../../offer/types/OfferType";
import {useAppDispatch} from "../../store/hooks";
import {howSearchWorksInfoData} from "../constants/how_search_works_info_data";
import {openForYouModal} from "../state/for_you_modal_slice";

export const ForYouHowItWorks = () => {
    const dispatch = useAppDispatch();

    const onClick = () => {
        dispatch(openForYouModal([OfferType.FLAT, OfferType.HOUSE]));
    };

    return (
        <Container as="section" className={sectionStyle}>
            <Text variant="headline_3" mb={4} align="center">
                Jak wygląda poszukiwanie mieszkania z naszym konsultantem?
            </Text>

            <div className={infoWrapper}>
                {howSearchWorksInfoData.map((data, index) => (
                    <div key={data.title} className={css(infoHolderRaw)}>
                        <div className={css(numberBadgeRaw, index === 0 && primaryBadgeRaw)}>
                            <Text variant="headline_4" as="p">
                                {index + 1}
                            </Text>
                        </div>
                        <div className={css(flexColumnCenterRaw, {gap: 3})}>
                            <div className={textHolder}>
                                <Text variant={data.titleVariant} className={textAlign}>
                                    {data.title}
                                </Text>
                                <Text variant={data.copyVariant} className={textAlign}>
                                    {data.copy}
                                </Text>
                            </div>
                            {data.additionalComponent?.(onClick) || null}
                        </div>
                    </div>
                ))}
            </div>
        </Container>
    );
};

const flexColumnCenterRaw = css.raw({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
});

const sectionStyle = css({
    marginTop: 8,
    marginBottom: 8,
    backgroundColor: "white",
    padding: 2,
    borderRadius: 2,

    md: {
        padding: 4
    }
});

const infoWrapper = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "space-between",

    md: {
        flexDirection: "row"
    }
});

const infoHolderRaw = css.raw({
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    alignItems: "start",
    padding: 3,
    gap: 3,
    width: "100%",

    md: {
        ...flexColumnCenterRaw,
        justifyContent: "space-between",
        width: "25%"
    }
});

const textHolder = css({
    ...flexColumnCenterRaw,
    gap: 1
});

const textAlign = css({
    width: "100%",
    textAlign: "start",

    md: {
        textAlign: "center"
    }
});

const numberBadgeRaw = css.raw({
    ...flexColumnCenterRaw,
    width: "64px",
    height: "64px",
    borderRadius: 4,
    backgroundColor: "var(--colors-background-200)",
    flexShrink: 0,

    md: {
        backgroundColor: "var(--colors-success)"
    }
});

const primaryBadgeRaw = css.raw({
    backgroundColor: "var(--colors-primary)",

    md: {
        backgroundColor: "var(--colors-primary)"
    }
});
import React from "react";
import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {Text} from "@pg-design/text-module";

import {OfferType} from "../../offer/types/OfferType";
import {useAppDispatch} from "../../store/hooks";
import {howSearchWorksInfoData} from "../constants/how_search_works_info_data";
import {openForYouModal} from "../state/for_you_modal_slice";

export const ForYouHowItWorks = () => {
    const dispatch = useAppDispatch();

    const onClick = () => {
        dispatch(openForYouModal([OfferType.FLAT, OfferType.HOUSE]));
    };

    return (
        <Container as="section" className={sectionStyle}>
            <Text variant="headline_3" mb={4} align="center">
                Jak wygląda poszukiwanie mieszkania z naszym konsultantem?
            </Text>

            <div className={infoWrapper}>
                {howSearchWorksInfoData.map((data, index) => (
                    <div key={data.title} className={css(infoHolderRaw)}>
                        <div className={css(numberBadgeRaw, index === 0 && primaryBadgeRaw)}>
                            <Text variant="headline_4" as="p">
                                {index + 1}
                            </Text>
                        </div>
                        <div className={css(flexColumnCenterRaw, {gap: 3})}>
                            <div className={textHolder}>
                                <Text variant={data.titleVariant} className={textAlign}>
                                    {data.title}
                                </Text>
                                <Text variant={data.copyVariant} className={textAlign}>
                                    {data.copy}
                                </Text>
                            </div>
                            {data.additionalComponent?.(onClick) || null}
                        </div>
                    </div>
                ))}
            </div>
        </Container>
    );
};

const flexColumnCenterRaw = css.raw({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
});

const sectionStyle = css({
    marginTop: 8,
    marginBottom: 8,
    backgroundColor: "white",
    padding: 2,
    borderRadius: 2,

    md: {
        padding: 4
    }
});

const infoWrapper = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "space-between",

    md: {
        flexDirection: "row"
    }
});

const infoHolderRaw = css.raw({
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    alignItems: "start",
    padding: 3,
    gap: 3,
    width: "100%",

    md: {
        ...flexColumnCenterRaw,
        justifyContent: "space-between",
        width: "25%"
    }
});

const textHolder = css({
    ...flexColumnCenterRaw,
    gap: 1
});

const textAlign = css({
    width: "100%",
    textAlign: "start",

    md: {
        textAlign: "center"
    }
});

const numberBadgeRaw = css.raw({
    ...flexColumnCenterRaw,
    width: "64px",
    height: "64px",
    borderRadius: 4,
    backgroundColor: "var(--colors-background-200)",
    flexShrink: 0,

    md: {
        backgroundColor: "var(--colors-success)"
    }
});

const primaryBadgeRaw = css.raw({
    backgroundColor: "var(--colors-primary)",

    md: {
        backgroundColor: "var(--colors-primary)"
    }
});
